import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SignIn from "../features/auth/pages/SignIn";
import Dashboard from "../features/dashboard/pages/Dashboard";
import RolesList from "../features/roles/pages/RolesList";
import DesignationsList from "../features/designations/pages/DesignationsList";
import UsersList from "../features/users/pages/UsersList";
import UserDetail from "../features/users/pages/UserDetail";
import DepartmentsPage from "../features/masters/departments/DepartmentsPage";
import HrDesignationsPage from "../features/masters/designations/HrDesignationsPage";
import TaxPage from "../features/masters/tax/TaxPage";
import DeductionsPage from "../features/masters/deductions/DeductionsPage";
import HolidaysPage from "../features/masters/holidays/HolidaysPage";
import CustomersList from "../features/masters/customers/pages/CustomersList";
import CustomerForm from "../features/masters/customers/pages/CustomerForm";
import GuardingAssignmentsPage from "../features/masters/customers/pages/GuardingAssignmentsPage";
import BulkGuardsPage from "../features/masters/customers/pages/BulkGuardsPage";
import CustomerFieldVisitsPage from "../features/masters/customers/pages/CustomerFieldVisitsPage";
import CustomerLocationsMapPage from "../features/masters/customers/pages/CustomerLocationsMapPage";
import ProductsList from "../features/masters/products/pages/ProductsList";
import ProductForm from "../features/masters/products/pages/ProductForm";
import ProductGroupsPage from "../features/masters/products/pages/ProductGroupsPage";
import EmployeesList from "../features/masters/employees/pages/EmployeesList";
import EmployeeForm from "../features/masters/employees/pages/EmployeeForm";
import VehiclesList from "../features/masters/vehicles/pages/VehiclesList";
import VehicleForm from "../features/masters/vehicles/pages/VehicleForm";
import LpoList from "../features/stock/lpo/pages/LpoList";
import LpoForm from "../features/stock/lpo/pages/LpoForm";
import LpoDetail from "../features/stock/lpo/pages/LpoDetail";
import PendingVehicleRequests from "../features/stock/lpo/pages/PendingVehicleRequests";
import StockInList from "../features/stock/stock-in/pages/StockInList";
import StockInForm from "../features/stock/stock-in/pages/StockInForm";
import StockInDetail from "../features/stock/stock-in/pages/StockInDetail";
import StockOutList from "../features/stock/stock-out/pages/StockOutList";
import StockOutForm from "../features/stock/stock-out/pages/StockOutForm";
import StockOutDetail from "../features/stock/stock-out/pages/StockOutDetail";
import StockReturnList from "../features/stock/returns/pages/StockReturnList";
import StockReturnForm from "../features/stock/returns/pages/StockReturnForm";
import StockReturnDetail from "../features/stock/returns/pages/StockReturnDetail";
import StockAdjustmentList from "../features/stock/adjustments/pages/StockAdjustmentList";
import StockAdjustmentForm from "../features/stock/adjustments/pages/StockAdjustmentForm";
import StockAdjustmentDetail from "../features/stock/adjustments/pages/StockAdjustmentDetail";
import StockBalancesPage from "../features/stock/balances/pages/StockBalancesPage";
import FeedbackInbox from "../features/feedback/pages/FeedbackInbox";
import SettingsPage from "../features/settings/pages/SettingsPage";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "./ProtectedRoute";
import PermissionRoute from "./PermissionRoute";
import { paths } from "./paths";

const AppRoutes = () => (
  <Routes>
    <Route path={paths.signin} element={<SignIn />} />

    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to={paths.dashboard} replace />} />
        <Route path={paths.dashboard} element={<Dashboard />} />
        <Route
          path={paths.roles}
          element={
            <PermissionRoute code="Admin.ManageRoles">
              <RolesList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.designations}
          element={
            <PermissionRoute code="Admin.ManageDesignations">
              <DesignationsList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.feedback}
          element={
            <PermissionRoute code="Admin.ManageFeedback">
              <FeedbackInbox />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.settings}
          element={
            <PermissionRoute code="Settings.ManageIntegrations">
              <SettingsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.users}
          element={
            <PermissionRoute code="Admin.ManageUsers">
              <UsersList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.userDetail()}
          element={
            <PermissionRoute code="Admin.ManageUsers">
              <UserDetail />
            </PermissionRoute>
          }
        />

        {/* HR master screens - each page has its own {Page}.View permission
            (handoff §13.3); write-gating (.Create/.Edit) happens in-page. */}
        <Route
          path={paths.hrDepartments}
          element={
            <PermissionRoute code="Departments.View">
              <DepartmentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrDesignations}
          element={
            <PermissionRoute code="Designations.View">
              <HrDesignationsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrTax}
          element={
            <PermissionRoute code="Tax.View">
              <TaxPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrDeductions}
          element={
            <PermissionRoute code="Deductions.View">
              <DeductionsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.hrHolidays}
          element={
            <PermissionRoute code="Holidays.View">
              <HolidaysPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customers}
          element={
            <PermissionRoute code="Customers.View">
              <CustomersList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerNew}
          element={
            <PermissionRoute code="Customers.View">
              <CustomerForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerEdit()}
          element={
            <PermissionRoute code="Customers.View">
              <CustomerForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerGuarding()}
          element={
            <PermissionRoute code="Customers.View">
              <GuardingAssignmentsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerBulkGuards()}
          element={
            <PermissionRoute code="Customers.View">
              <BulkGuardsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerFieldVisits()}
          element={
            <PermissionRoute code="Customers.ViewLocation">
              <CustomerFieldVisitsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.customerLocationsMap}
          element={
            <PermissionRoute code="Customers.ViewLocation">
              <CustomerLocationsMapPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.products}
          element={
            <PermissionRoute code="Products.View">
              <ProductsList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.productGroups}
          element={
            <PermissionRoute code="Products.View">
              <ProductGroupsPage />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.productNew}
          element={
            <PermissionRoute code="Products.View">
              <ProductForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.productEdit()}
          element={
            <PermissionRoute code="Products.View">
              <ProductForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.employees}
          element={
            <PermissionRoute code="Employees.View">
              <EmployeesList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.employeeNew}
          element={
            <PermissionRoute code="Employees.View">
              <EmployeeForm mode="new" />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.employeeEdit()}
          element={
            <PermissionRoute code="Employees.View">
              <EmployeeForm mode="edit" />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.employeePromote()}
          element={
            <PermissionRoute code="Employees.View">
              <EmployeeForm mode="promote" />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.vehicles}
          element={
            <PermissionRoute code="Vehicles.View">
              <VehiclesList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.vehicleNew}
          element={
            <PermissionRoute code="Vehicles.View">
              <VehicleForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.vehicleEdit()}
          element={
            <PermissionRoute code="Vehicles.View">
              <VehicleForm />
            </PermissionRoute>
          }
        />

        {/* Stock Management - own top-level module, against
            TexasAlarms.Api's src/Stock module. */}
        <Route
          path={paths.stockLpos}
          element={
            <PermissionRoute code="Stock.ViewLpo">
              <LpoList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoPendingVehicleRequests}
          element={
            <PermissionRoute code="Stock.CreateLpo">
              <PendingVehicleRequests />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoNew}
          element={
            <PermissionRoute code="Stock.ViewLpo">
              <LpoForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoEdit()}
          element={
            <PermissionRoute code="Stock.ViewLpo">
              <LpoForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockLpoDetail()}
          element={
            <PermissionRoute code="Stock.ViewLpo">
              <LpoDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockIn}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockInNew}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockInDetail()}
          element={
            <PermissionRoute code="Stock.ViewStockIn">
              <StockInDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOut}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOutNew}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockOutDetail()}
          element={
            <PermissionRoute code="Stock.ViewStockOut">
              <StockOutDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturns}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturnNew}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockReturnDetail()}
          element={
            <PermissionRoute code="Stock.ViewReturn">
              <StockReturnDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustments}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentList />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustmentNew}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentForm />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockAdjustmentDetail()}
          element={
            <PermissionRoute code="Stock.ViewAdjustment">
              <StockAdjustmentDetail />
            </PermissionRoute>
          }
        />
        <Route
          path={paths.stockBalances}
          element={
            <PermissionRoute code="Stock.ViewBalance">
              <StockBalancesPage />
            </PermissionRoute>
          }
        />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to={paths.dashboard} replace />} />
  </Routes>
);

export default AppRoutes;
